import {ProcessInterface} from "../interface/ProcessInterface";
import configAxios from "../configuration/configAxios";
import {errorHandlerServices} from "../configuration/errorHandle";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {DocumentProcessInterface} from "../interface/DocumentProcessInterface";

export const findDocument = async (data: DocumentProcessInterface) => {
    return await configAxios.get(`/ms-archivos/documentProcess/findById`, {
        params: {
            id: data.idDocumentRepository
        }
    }).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return response.data.object
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-archivos/documentProcess/findById`);
    })
}

export const useFindDocument = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: ProcessInterface) => findDocument(data),
    });
}

export const deleteDocumentProcess = async (data: DocumentProcessInterface) => {
    return configAxios.delete(`/ms-archivos/documentProcess/delete-file`, {
        params: {
            fileId: data.idDocumentRepository
        }
    }).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return configAxios.delete(`/ms-menus/process/deleteDocumentProcess`, {
                params: {
                    idDocumentRepository: data.idDocumentRepository,
                }
            }).then((responseWS) => {
                return responseWS.data.object
            }).catch(error => {
                errorHandlerServices(error, true)
                throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/process/deleteDocumentProcess`);
            })
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/process/deleteDocumentProcess`);
    })
}

export const useDeleteDocumentProcess = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: DocumentProcessInterface) => deleteDocumentProcess(data),
    });
}
